export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-x-circle-07ff5f4234ec60ac139ce72990d21f97.svg";